(function () {
  function initSliders() {
    var params = new URLSearchParams(window.location.search);
    var source = params.get('source');
    var currentSource = source === 'core' || source === 'brighton' ? source : 'brighton';

    document.querySelectorAll('[data-slider]').forEach(function (root) {
      var viewport = root.querySelector('.hero-content-slider__viewport');
      var track = root.querySelector('.hero-content-slider__track');
      if (!viewport || !track) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide-index]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slide-to]'));
      var prevBtns = Array.prototype.slice.call(root.querySelectorAll('[data-slider-prev]'));
      var nextBtns = Array.prototype.slice.call(root.querySelectorAll('[data-slider-next]'));

      var visibleIndexes = [];
      slides.forEach(function (slide, i) {
        var visibleFor = slide.getAttribute('data-visible-for') || 'both';
        var isVisible = visibleFor === 'both' || visibleFor === currentSource;
        if (isVisible) {
          visibleIndexes.push(i);
        } else {
          slide.style.display = 'none';
          slide.classList.remove('is-active');
        }
      });

      if (visibleIndexes.length === 0) {
        slides.forEach(function (slide, i) {
          visibleIndexes.push(i);
          slide.style.display = '';
        });
      }

      dots.forEach(function (dot) {
        var di = parseInt(dot.getAttribute('data-slide-to'), 10);
        if (isNaN(di)) return;
        var show = visibleIndexes.indexOf(di) !== -1;
        dot.style.display = show ? '' : 'none';
        if (!show) dot.classList.remove('is-active');
      });

      if (visibleIndexes.length <= 1) {
        prevBtns.forEach(function (btn) {
          btn.style.display = 'none';
        });
        nextBtns.forEach(function (btn) {
          btn.style.display = 'none';
        });
      } else {
        prevBtns.forEach(function (btn) {
          btn.style.display = '';
        });
        nextBtns.forEach(function (btn) {
          btn.style.display = '';
        });
      }

      var currentPos = 0;
      var slideWidth = 0;

      function measure() {
        slideWidth = viewport.clientWidth;
        slides.forEach(function (slide) {
          if (slide.style.display === 'none') return;
          slide.style.flexShrink = '0';
          slide.style.flexBasis = slideWidth + 'px';
          slide.style.width = slideWidth + 'px';
          slide.style.maxWidth = slideWidth + 'px';
        });
      }

      function updateActiveClasses(activeSlideIndex) {
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === activeSlideIndex);
          var tb = slide.querySelector('.hero-content-slider__toolbar');
          if (tb) {
            tb.setAttribute('aria-hidden', i === activeSlideIndex ? 'false' : 'true');
          }
        });
        dots.forEach(function (dot) {
          var di = parseInt(dot.getAttribute('data-slide-to'), 10);
          if (isNaN(di)) return;
          dot.classList.toggle('is-active', di === activeSlideIndex);
        });
      }

      function scrollToVisibleIndex(visibleIndex, smooth) {
        if (visibleIndexes.length === 0) return;
        var bounded = (visibleIndex + visibleIndexes.length) % visibleIndexes.length;
        currentPos = bounded;
        var activeIndex = visibleIndexes[currentPos];
        var target = slides[activeIndex];
        if (!target || slideWidth <= 0) return;

        var left = target.offsetLeft;
        if (smooth) {
          viewport.scrollTo({ left: left, behavior: 'smooth' });
        } else {
          viewport.scrollLeft = left;
        }
        updateActiveClasses(activeIndex);
      }

      function syncFromScroll() {
        if (slideWidth <= 0 || visibleIndexes.length === 0) return;
        var scrollLeft = viewport.scrollLeft;
        var closest = visibleIndexes[0];
        var minDist = Infinity;
        visibleIndexes.forEach(function (vi) {
          var el = slides[vi];
          if (!el || el.style.display === 'none') return;
          var dist = Math.abs(el.offsetLeft - scrollLeft);
          if (dist < minDist) {
            minDist = dist;
            closest = vi;
          }
        });
        var posInVisible = visibleIndexes.indexOf(closest);
        if (posInVisible === -1) return;
        currentPos = posInVisible;
        updateActiveClasses(closest);
      }

      requestAnimationFrame(function () {
        measure();
        requestAnimationFrame(function () {
          scrollToVisibleIndex(0, false);
        });
      });

      prevBtns.forEach(function (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollToVisibleIndex(currentPos - 1, true);
        });
      });
      nextBtns.forEach(function (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollToVisibleIndex(currentPos + 1, true);
        });
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-slide-to'), 10);
          if (isNaN(i)) return;
          var pos = visibleIndexes.indexOf(i);
          if (pos !== -1) scrollToVisibleIndex(pos, true);
        });
      });

      var scrollDebounce;
      viewport.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollDebounce);
          scrollDebounce = setTimeout(syncFromScroll, 60);
        },
        { passive: true }
      );

      window.addEventListener('resize', function () {
        measure();
        scrollToVisibleIndex(currentPos, false);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }
})();
